import { InputAdornment } from '@mui/material';
import classNames from 'classnames';
import { NumberRangeFilterTypes } from '../../../../../../FilterV3/components/NumberRangeFilter/numberRangeFilter.types';
import MoneyTextField from '../../../../../../FormInputs/MoneyTextField';
import NumberTextField from '../../../../../../FormInputs/NumberTextField';
import useStyles from './inputHandler.styles';

interface InputHandlerProps {
  type: NumberRangeFilterTypes;
  value: number;
  onChange: (number: number) => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const InputHandler = ({
  type,
  onChange,
  value,
  error,
  helperText,
  disabled,
}: InputHandlerProps) => {
  const { classes } = useStyles();

  if (type === NumberRangeFilterTypes.PERCENTAGE) {
    return (
      <NumberTextField
        decimalScale={2}
        value={value}
        disabled={disabled}
        error={error}
        helperText={helperText}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(+event.target.value)}
        slotProps={{
          input: {
            className: classNames([classes.input, classes.percentageInput]),
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          },
        }}
      />
    );
  }

  if (type === NumberRangeFilterTypes.MONETARY) {
    return (
      <MoneyTextField
        value={value}
        disabled={disabled}
        error={error}
        helperText={helperText}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(+event.target.value)}
        slotProps={{
          input: {
            className: classNames([classes.input, classes.monetaryInput]),
          },
        }}
      />
    );
  }

  if (type === NumberRangeFilterTypes.INTEGER) {
    return (
      <NumberTextField
        decimalScale={0}
        value={value}
        disabled={disabled}
        error={error}
        helperText={helperText}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(+event.target.value)}
        slotProps={{
          input: {
            className: classes.input,
          },
        }}
      />
    );
  }

  throw new Error('type para InputHandle não implementado');
};

export default InputHandler;
